import { render, staticRenderFns } from "./SmsMessageForm.vue?vue&type=template&id=af0942ee"
import script from "./SmsMessageForm.vue?vue&type=script&lang=js"
export * from "./SmsMessageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports